<swiper [config]="newConfig">
    <div class="home-slide-wrapper">
        <div class="container">
            <div class="intro-text">
              <div class="intro-lead-in">Welcome To FS Personnel!</div>
              <div class="intro-heading text-uppercase">It's Nice To Meet You</div>
              <a matRipple  class="btn btn-fsp btn-xl text-uppercase js-scroll-trigger" routerLink="/" (click)="scrollToElement('team')">Meet our Team </a>
            </div>
        </div>
    </div>
    <div class="home-slide-wrapper">
        <div class="container">
            <div class="intro-text">
              <div class="intro-lead-in">Jobs Available!</div>
              <div class="intro-heading text-uppercase">Browse available Jobs</div>
              <a matRipple  class="btn btn-fsp btn-xl text-uppercase js-scroll-trigger" routerLink="/jobs">Jobs</a>
            </div>
        </div>
    </div>
    <div class="home-slide-wrapper">
        <div class="container">
            <div class="intro-text">
              <div class="intro-lead-in">Our Services</div>
              <div class="intro-heading text-uppercase text-resizable">FS Personnel specializes in staff recruitment, selection and placement, both in PERMANENT and TEMPORARY STAFF</div>
              <a matRipple  class="btn btn-fsp btn-xl text-uppercase js-scroll-trigger" routerLink="/services">Services</a>
            </div>
        </div>
    </div>
    <div class="home-slide-wrapper">
        <div class="container">
            <div class="intro-text">
              <div class="intro-lead-in">Quote of the day</div>
              <div class="intro-heading text-uppercase text-resizable">Choose a job you love, and you will never have to work a day in your life.</div>
              <a matRipple  class="btn btn-fsp btn-xl text-uppercase js-scroll-trigger" routerLink="/advices">Advices</a>
            </div>
        </div>
    </div>
</swiper>